// src/components/Admin/StudentHomeCmp/StudenthomeGrid.jsx (Module1)
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid, Button, Icon } from "semantic-ui-react";
import "./Module1.scss";

const virtualScenesController = new VirtualScenes();

// AÑADIMOS 'pdfUrl' a las props
export function Module1({ refId, onLoadComplete, pdfUrl }) {
  const module1 = "module_01";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModuleData = useCallback(async () => {
    // ... (la lógica de fetch de Module1 no cambia)
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module1
      );
      setModuleData(data.moduleData);
      if (data.moduleData?.bannertop) {
        const bannerData = await virtualScenesController.getRepoScene(
          data.moduleData.bannertop,
          accessToken
        );
        setBannerUrl(bannerData.url);
      }
    } catch (err) {
      console.error("Error al obtener los datos del módulo o banner:", err);
      setError("Error al cargar el módulo o el banner");
    } finally {
      setLoading(false);
      if (onLoadComplete) onLoadComplete();
    }
  }, [refId, accessToken, module1, onLoadComplete]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  const {
    ModOneTitle,
    ModOneDescription,
    ModOneTags,
    ModOneCategory,
    ModOneSubcategory,
  } = moduleData || {};

  return (
    <div className="module1-container">
      <Grid stackable columns={2} className="module1-grid">
        <Grid.Column width={8} className="module1-text-column">
          {/* ... (resto del JSX de la columna de texto sin cambios) ... */}
          <div>
            <h2 className="module1-title">
              {ModOneTitle || "Título no disponible"}
            </h2>
            <div
              className="module1-description"
              dangerouslySetInnerHTML={{
                __html: ModOneDescription || "Sin descripción",
              }}
            />
            <div className="module1-tags">
              <p>
                <strong>Palabras clave:</strong>
                {ModOneTags?.length > 0
                  ? ModOneTags.map((tag) => ` #${tag}`).join("")
                  : " No hay palabras clave"}
              </p>
            </div>
          </div>
          <div className="module1-spacer" />
          
          {/* --- Bloque Inferior con el botón MODIFICADO --- */}
          <div>
            {/* El botón ahora es condicional y funcional */}
            {pdfUrl && (
              <Button
                className="module1-download-button"
                as="a" // Se renderiza como una etiqueta <a>
                href={pdfUrl} // Usa la URL del PDF
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name="download" />
                Contexto
              </Button>
            )}
            <p className="module1-category">
              {ModOneCategory?.join(", ") || "Sin categoría"} -{" "}
              {ModOneSubcategory?.join(", ") || "Sin subcategorías"}
            </p>
          </div>
        </Grid.Column>
        {/* ... (resto del JSX sin cambios) ... */}
        <Grid.Column width={8} className="module1-image">
          {bannerUrl ? (
            <img
              src={bannerUrl}
              alt="Vista del módulo"
              className="module1-banner"
            />
          ) : (
            <div className="module1-placeholder">No hay imagen disponible</div>
          )}
        </Grid.Column>
      </Grid>
    </div>
  );
}